<template>
  <PullRefresh
    v-model="isLoading"
    success-text="刷新成功"
    :disabled="!isLive"
    @refresh="onRefresh"
  >
    <div v-if="!isLive" class="pageNative flex_center">
      <div
        v-if="isNotStart"
        class="nativeStatus flex_center"
      >
        活动将于 {{ activityInfo.startTime }} 开始
      </div>
      <div
        v-else
        class="nativeStatus flex_center"
      >
        活动已结束
      </div>
    </div>
    <div v-else class="page">
      <!-- 头图 -->
      <div
        class="page_header bg_contain"
        :style="{
          backgroundImage: `url(${activityInfo.icon})`,
        }"
      >
      </div>
      <div class="main">
        <div class="block">
          <div class="block_title">
            <img :src="`${CDN_URL}/title_rec.png`" alt="">
          </div>
          <GameBlock
            :type="1"
            :list="recommendList"
            @go="g => onGoDetail(g, 1)"
            @expandChange="onExpand"
          />
        </div>
        <div class="block mt_8">
          <div class="block_title">
            <img :src="`${CDN_URL}/title_playing.png`" alt="">
          </div>
          <GameBlock
            :type="2"
            :list="playList"
            @go="g => onGoDetail(g, 2)"
            @expandChange="onExpand"
          />
        </div>
      </div>
    </div>
    
  </PullRefresh>
</template>
<script>
import {
  setPageTitle, setRightTxt, clickRightTxt, toLogin,
} from "@/bridge/AppJsBridge";
import { PullRefresh } from "vant";
import EventTrack from '@/mixins/eventTrack'
import LinkTo from '@/mixins/linkTo'
import { CDN_URL } from "./config";
import { getActiveInfoApi, getActivePlaceListApi, checkActivePlaceApi } from '@/apis/btBoxActivity'
import GameBlock from './gameBlock.vue'
import { ActivityInfo } from './config'
import AvoidFirstActivate from '@/mixins/avoidFirstActivate'

export default {
  components: {
    PullRefresh,
    GameBlock,
  },
  mixins: [EventTrack, LinkTo, AvoidFirstActivate],
  data () {
    return {
      activityInfo: new ActivityInfo(),
      CDN_URL,
      isLoading: false,
      playList: [],
      recommendList: [],
      showAllPlaying: false,
      showAllRecommend: false,
      goLoading: false,
      hasFetched: false,
    }
  },
  computed: {
    actId () {
      return this.$route.query.id || 2
    },
    isLive () {
      if (!this.hasFetched) return true
      if (!this.activityInfo.id && this.hasFetched) return false
      return !this.isNotStart && !this.isPassed
    },
    isPassed () {
      const { endTime } = this.activityInfo
      const now = Date.now()
      return now > new Date(endTime).getTime()
    },
    isNotStart () {
      const { startTime } = this.activityInfo
      const now = Date.now()
      return now < new Date(startTime).getTime()
    },
  },
  activated () {
    this.hasFetched = false
    if (this.activityInfo.title) {
      setRightTxt('活动规则');
      setPageTitle(this.activityInfo.title)
    }
  },
  methods: {
    init () {
      return this.getActInfo().then(res => {
        this.eventTrack({
          event: "register_active_place_show",
          event_field: this.getTrackInfo(),
        })
        setPageTitle(this.activityInfo.title)
        this.hasFetched = true
        this.setHeaderContent()
      })
    },
    getActivityInfo () {
      this.init()
    },
    onRefresh () {
      this.init().finally(res => {
        setTimeout(() => {
          this.isLoading = false
        }, 100)
      })
    },
    getActInfo () {
      return getActiveInfoApi({ id: this.actId }).then(res => {
        this.activityInfo = res.data || new ActivityInfo()
        setTimeout(() => {
          if (this.isLive) this.getGameList()
        })
      }).catch(err => {
        if (err.response && err.response.data.code === 401) {
          toLogin("/loginKey/LoginByKeyPhoneActivity")
        }
      })
    },
    getGameList () {
      return getActivePlaceListApi({ id: this.actId }).then(res => {
        const { recommendList, playList } = res.data
        this.playList = playList || []
        this.recommendList = recommendList || []
        this.showAllPlaying = this.playList.length <= 3
        this.showAllRecommend = this.recommendList.length <= 3
      })
    },
    
    onGoDetail (g, type) {
      const { placeId, gameId, gameName } = g || {}
      if (this.goLoading) return
      this.goLoading = true
      this.eventTrack({
        event: "register_active_place_join",
        event_field: this.getTrackInfo({ game_id: gameId, game_name: gameName }),
      })
      checkActivePlaceApi({
        placeId,
        activityId: this.actId,
      }).then(res => {
        if (res.data) {
          this.$router.push({
            name: 'box.activeRegister.game',
            query: {
              placeId,
              id: this.actId,
            }
          })
        } else {
          this.$toast('福利上架中')
        }
      }).catch(err => {
        const { code, msg } = err
        const errorCodes = [90601, 90702]
        if (errorCodes.includes(code)) {
          this.$toast(msg)
          this.getActInfo()
        }
      }).finally(() => {
        setTimeout(() => {
          this.goLoading = false
        }, 300)
      })
    },
    onExpand (type, scene_type) {
      this.eventTrack({
        event: "register_active_place_more",
        event_field: this.getTrackInfo({ type: type ? 1 : 2, scene_type }),
      })
    },
    // 设置顶部内容
    setHeaderContent() {
      setRightTxt("活动规则");
      clickRightTxt(() => {
        this.eventTrack({
          event: "register_active_rule",
          event_field: this.getTrackInfo(),
        })
        this.handleGoRulePage(18)
      });
    },
    getTrackInfo (params = {}) {
      return JSON.stringify({
        activity_id: this.activityInfo.id,
        title: this.activityInfo.title,
        ...params,
      })
    },
  },
}
</script>

<style scoped lang="scss">
@import "./index.scss";
.pageNative {
  background-color: #DEECEA;
}
</style>
